<!-- payments-entity.component.html -->
<app-entity-mat-dialog-title title="Payment"></app-entity-mat-dialog-title>

<app-payments-entity-form></app-payments-entity-form>
